import permissions from "app/permissions";
import { CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS_DETAILS, StudentServicePath } from "utils/constants";
import ShowCurriculumSelectionCampaignApplication from "./Show";

export const resources = {
  isMenu: false,
  name: StudentServicePath + CURRICULUM_SELECTION_CAMPAIGN_APPLICATIONS_DETAILS,
  custom: <ShowCurriculumSelectionCampaignApplication />,
  permission: permissions.canPreviewCurriculumSelectionCampaigns,
};
